module.exports = __webpack_public_path__ + "img/qgjj-01.prt.bcef2c09.jpg";